import {
  SHOW_CHART_REPORT_SOURCE_CUSTOMER,
  SHOW_CHART_REPORT_SOURCE_SERVICE,
} from "app/appConfig";
import { PAGESIZE_ALL, SERVICE_UNSPECIFIED_DEPOSIT } from "app/common/LocalConst";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingAbstractProductService } from "app/services/AbstractProductService";
import {
  exportExcelRevenue,
  getRevenueReportCombined,
} from "app/services/ReportService";
import { pagingServiceGroup } from "app/services/ServiceGroupService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportRevenueDetailStore {
  pageDataRevenueDetail = new PageResponse();
  chartDataRevenueDetail = null;
  countDataRevenueDetail = new PageResponse();
  totalAmount = 0;
  totalFee = 0;
  totalRevenueAfterFee = 0;
  searchReportRevenueDetail = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    currentPatientSourceDetailId: null,
    currentPatientSourceId: null,

    departmentIds: [],
    // orgIds: [],
    serviceGroupIds: [],
    drugGroupIds: [],
    cardGroupIds: [],
    consultantStaffIds: [],
    saleStaffIds: [],
    sourceIds: [],
    currentPatientSourceDetailIds: [],
    currentPatientSourceIds: [],
    positionIds: [],
    drugIds: [],
    serviceIds: [],
    cardIds: [],
  };

  searchReportChart = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentIds: [],
    sourceIds: [],
  };
  dataGroupItem = [];

  isLoading = false;
  constructor() {
    makeAutoObservable(this);
  }
  handleChangeFormSearchRevenueDetail = async (searchReportRevenueDetail) => {
    this.isLoading = true;
    try {
      this.searchReportRevenueDetail = {
        ...this.searchReportRevenueDetail,
        ...searchReportRevenueDetail,
      };

      // 1 request gộp thay cho 4-5 API (page/count/total/source/patient-source).
      // Backend materialize CTE nặng 1 lần rồi suy ra tất cả -> nhanh hơn ~3-4×.
      await this.fetchRevenueReportCombined();
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  };

  fetchRevenueReportCombined = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (
      !this.searchReportRevenueDetail.departmentIds ||
      this.searchReportRevenueDetail.departmentIds.length === 0
    ) {
      this.pageDataRevenueDetail = new PageResponse();
      this.countDataRevenueDetail = new PageResponse();
      this.chartDataRevenueDetail = null;
      this.totalAmount = 0;
      this.totalFee = 0;
      this.totalRevenueAfterFee = 0;
      return;
    }

    const search = this.normalizeSearchReportRevenueDetail(
      this.searchReportRevenueDetail
    );
    try {
      const { data } = await getRevenueReportCombined({ ...search });

      // page vừa chứa content (bảng) vừa chứa totalElements/totalPages (phân trang)
      const page = data?.page || new PageResponse();
      this.pageDataRevenueDetail = page;
      this.countDataRevenueDetail = page;

      this.totalAmount = data?.total?.totalRevenue || 0;
      this.totalFee = data?.total?.totalFee || 0;
      this.totalRevenueAfterFee = data?.total?.totalRevenueAfterFee || 0;

      this.chartDataRevenueDetail = {
        dataChartService: SHOW_CHART_REPORT_SOURCE_SERVICE
          ? data?.revenueSource
          : null,
        dataChartSource: SHOW_CHART_REPORT_SOURCE_CUSTOMER
          ? data?.patientSource
          : null,
      };
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu báo cáo doanh thu chi tiết (nguồn) có lỗi");
    }
  };

  normalizeSearchReportRevenueDetail = (rawSearch = {}) => {
    const {
      departmentIds,
      // orgIds,
      staffId,
      currentPatientSourceId,
      currentPatientSourceDetailId,
      drugGroupIds,
      serviceGroupIds,
      cardGroupIds,
      drugIds,
      serviceIds,
      cardIds,
      consultantStaffIds,
      saleStaffIds,
      currentPatientSourceDetailIds,
      sourceIds,
      currentPatientSourceIds,
      positionIds,
      staffIds,
      voucherCode,
      platforms,
      groupNameList,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      currentPatientSourceIds: currentPatientSourceIds
        ? currentPatientSourceIds.map((x) => x.id)
        : null,
      drugGroupIds: drugGroupIds ? drugGroupIds.map((x) => x.id) : null,
      serviceGroupIds: serviceGroupIds
        ? serviceGroupIds.map((x) => x.id)
        : null,
      cardGroupIds: cardGroupIds ? cardGroupIds.map((x) => x.id) : null,
      drugIds: drugIds ? drugIds.map((x) => x.id) : null,
      serviceIds: serviceIds ? serviceIds.map((x) => x.id) : null,
      consultantStaffIds: consultantStaffIds
        ? consultantStaffIds.map((x) => x.id)
        : null,
      saleStaffIds: saleStaffIds ? saleStaffIds.map((x) => x.id) : null,

      currentPatientSourceDetailIds: currentPatientSourceDetailIds
        ? currentPatientSourceDetailIds.map((x) => x.id)
        : null,
      staffId: staffId?.id,
      currentPatientSourceId: currentPatientSourceId?.id,
      currentPatientSourceDetailId: currentPatientSourceDetailId?.id,
      positionIds:
        positionIds?.length > 0 ? positionIds.map((x) => x.id) : null,

      staffIds: staffIds?.length > 0 ? staffIds.map((x) => x.id) : null,

      departmentIds:
        departmentIds?.length > 0 ? departmentIds.map((x) => x?.id) : null,
      sourceIds: sourceIds?.length > 0 ? sourceIds.map((x) => x.id) : null,
      platforms: Array.isArray(platforms) && platforms.length > 0
        ? platforms.map((x) => (typeof x === "string" ? x : x.value))
        : null,
      groupNameList: groupNameList ? groupNameList.map((x) => x.name) : null,
      voucherCode: voucherCode?.trim() || null,
    };
  };

  normalizeSearchReportChart = (rawSearch = {}) => {
    const {
      departmentIds,
      sourceIds,
      positionIds,
      staffIds,
      voucherCode,
      groupNameList,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      // orgIds: Array.isArray(orgIds) ? orgIds.map((x) => x.id) : [],
      positionIds:
        positionIds?.length > 0 ? positionIds.map((x) => x.id) : null,

      staffIds: staffIds?.length > 0 ? staffIds.map((x) => x.id) : null,
      groupNameList: groupNameList ? groupNameList.map((x) => x.name) : null,
      departmentIds:
        departmentIds?.lenght > 0 ? departmentIds.map((x) => x.id) : null,
      sourceIds: sourceIds?.length > 0 ? sourceIds.map((x) => x.id) : null,
      voucherCode: voucherCode?.trim() || null,
    };
  };

  handleExportRevenueReport = async (searchObj) => {
    if (!(searchObj?.departmentIds?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    try {
      const response = await exportExcelRevenue(
        this.normalizeSearchReportRevenueDetail({
          ...this.searchReportRevenueDetail,
          ...searchObj,
        })
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "BAO_CAO_DOANH_THU_CHI_TIET_THEO_NGUON.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        console.error("Export failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  getDataGroupName = async () => {
    try {
      const dataServiceGroup = await pagingServiceGroup({
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
        isUse: true,
      });

      if (dataServiceGroup?.data?.content?.length > 0) {
        this.dataGroupItem.push(...dataServiceGroup?.data?.content);
      }

      const dataProductGroup = await pagingAbstractProductService({
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
        isUse: true,
      });

      if (dataProductGroup?.data?.content?.length > 0) {
        this.dataGroupItem.push(...dataProductGroup?.data?.content);
      }
      this.dataGroupItem.push({
        name: "Cọc không xác định dịch vụ",
        id: SERVICE_UNSPECIFIED_DEPOSIT,
      });
    } catch (error) {
      toast.error("Lấy dữ liệu nhóm có lỗi");
    }
  };
  resetStore = () => {
    this.totalAmount = 0;
    this.totalFee = 0;
    this.totalRevenueAfterFee = 0;
    this.dataGroupItem = [];
  };
}
